<template>
	<div id='app' class='page-wrapper'>
		<Page />
	</div>
</template>

<script>
import Page from './components/Page.vue'

export default {
	name: 'app',
	components: {
		Page
	}
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Inconsolata:400,700&display=swap');

html,
body {
	padding: 0;
	margin: 0;
}

p, a, h1, h2, h3, h4, h5, h6 {
	font-family: Inconsolata, monospace;
}

.page-wrapper {
	display: flex;
	justify-content: center;
	align-content: center;
}
</style>
